// removed by extract-text-webpack-plugin
module.exports = {"popwrap":"Popup-CreateBidResult-popwrap","icon":"Popup-CreateBidResult-icon","icon-success":"Popup-CreateBidResult-icon-success","icon-fail":"Popup-CreateBidResult-icon-fail","title":"Popup-CreateBidResult-title","message":"Popup-CreateBidResult-message","button":"Popup-CreateBidResult-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/CreateBidResult/index.css
// module id = 1725
// module chunks = 0